import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Wrapper,
  ContentContainer,
  TitleText,
  ContentTitle,
  ContentMainImage,
  ItemCareContainer,
  ContentMainImageText,
  ContentMainImageTitle,
  ContentMainImageDescription,
  ContentMainImageImage,
  ContentInner,
  VideoSection,
  ItemCareStepContainer,
  // ItemCareStepContent,
  ItemCareStepImage,
  ItemCareStepTitle,
  ItemCareStepDescription,
  // ItemCareMemoContainer,
  // ItemCareMemoContent,
  // ItemCareMemoTitle,
  // ItemCareMemoDescription,
  // ItemCareMemo,
  ItemCareStepTextContainer,
} from './SublimicHomeCareStep.style';
import Image from '../../../components/ContentfulImage';
import Video from '../../../components/BrightcoveVideo';
import Placeholder from '../../../components/Placeholder';
import Markdown from '../../../components/Markdown';

const SublimicHomeCareStepPage = ({ copy, match, siteOptions }) => {
  // const { copy, match } = this.props;
  const { slug } = match.params;
  const ownCopy = siteOptions.siteCopy ? siteOptions.siteCopy.homeCareItemStep : {};
  let product = {};

  if (Object.keys(copy).length > 0) {
    // HomeCareProductを抽出 & slugに該当するProductに絞り込み
    // const subCategories = [...copy.hairCareItems, ...copy.scalpCareItems].reduce(
    //   (nv, line) => [...nv, ...line.categories.reduce((nv2, category) => [...nv2, ...category.subCategories], [])],
    //   []
    // );
    const subCategories = [...copy.hairCareItems, ...copy.scalpCareItems].reduce(
      (nv, line) => [
        ...nv,
        ...line.categories.reduce(
          (nv2, category) => [
            ...nv2,
            ...category.subCategories.map(subCategory => {
              const item = { ...subCategory, lineName: line.name };
              return item;
            }),
          ],
          []
        ),
      ],
      []
    );
    product = subCategories.find(item => item.slug === slug);
  } else {
    product = {
      steps: {
        description: undefined,
        image: undefined,
        steps: [
          {
            entryId: 1,
            title: undefined,
            description: undefined,
            image: undefined,
          },
          {
            entryId: 2,
            title: undefined,
            description: undefined,
            image: undefined,
          },
          {
            entryId: 3,
            title: undefined,
            description: undefined,
            image: undefined,
          },
          {
            entryId: 4,
            title: undefined,
            description: undefined,
            image: undefined,
          },
        ],
      },
    };
  }

  // let homeCareStep = {};
  // copy &&
  //   copy.hairCareItems &&
  //   copy.hairCareItems.map(hcitem => {
  //     hcitem.categories.map(cate => {
  //       if (Object.keys(homeCareStep).length === 0 && homeCareStep.constructor === Object) {
  //         const subCategories = cate.subCategories.find(item => item.slug === slug);
  //         homeCareStep = subCategories && subCategories.steps ? subCategories.steps : {};
  //       }
  //     });
  //   });

  return (
    <React.Fragment>
      {product && (
        <Wrapper>
          <TitleText>{ownCopy.title || <Placeholder w={['80%', '50%']} h={['30px', '45px']} />}</TitleText>
          <ContentContainer>
            <ItemCareContainer>
              <ContentMainImage>
                <ContentMainImageText>
                  <ContentMainImageTitle>
                    {product.lineName || <Placeholder w="150px" h="16px" mb="50px" />}
                  </ContentMainImageTitle>
                  <Markdown
                    src={(product.steps && product.steps.description) || ''}
                    Component={ContentMainImageDescription}
                  />
                </ContentMainImageText>
                <ContentMainImageImage>
                  {product.steps && product.steps.image ? (
                    <Image
                      src={product.steps.image}
                      options={{ w: '100%', h: '100%', objectFit: 'cover', objectPosition: 'right' }}
                    />
                  ) : (
                    <Placeholder w="100%" h="100%" pb="60px" />
                  )}
                </ContentMainImageImage>
              </ContentMainImage>
              <ContentInner>
                <ContentTitle>
                  {(product.steps && product.steps.title && product.steps.title) || <Placeholder w="150px" h="16px" />}
                </ContentTitle>
                <VideoSection>
                  {product.steps && product.steps.video && <Video {...product.steps.video} />}
                </VideoSection>
                {product.steps &&
                  product.steps.steps.map(step => (
                    <ItemCareStepContainer key={step.entryId}>
                      <ItemCareStepTextContainer>
                        <ItemCareStepTitle>{step.title || <Placeholder w="100%" h="16px" />}</ItemCareStepTitle>
                        {step.description ? (
                          <Markdown src={step.description} Component={ItemCareStepDescription} />
                        ) : (
                          <ItemCareStepDescription>
                            <Placeholder w="100%" h="16px" />
                          </ItemCareStepDescription>
                        )}
                      </ItemCareStepTextContainer>
                      {step.image && (
                        <ItemCareStepImage>
                          <Image
                            src={step.image}
                            options={{
                              w: '100%',
                              h: '100%',
                              objectFit: ['contain', 'cover'],
                              objectPosition: ['top', 'unset'],
                            }}
                          />
                        </ItemCareStepImage>
                      )}
                    </ItemCareStepContainer>
                  ))}
                {/* <ItemCareMemoContainer>
                  <ItemCareMemoContent>
                    <ItemCareMemoTitle>{ homeCareStep.memo && 'Memo' || ''}</ItemCareMemoTitle>
                    <ItemCareMemoDescription>
                      {homeCareStep.memo && 
                        homeCareStep.memo
                          .split(";")
                          .map((memo, index) => (
                            <ItemCareMemo key={index}>{memo}</ItemCareMemo>
                          ))}
                    </ItemCareMemoDescription>
                  </ItemCareMemoContent>
                </ItemCareMemoContainer> */}
              </ContentInner>
            </ItemCareContainer>
          </ContentContainer>
        </Wrapper>
      )}
    </React.Fragment>
  );
};

SublimicHomeCareStepPage.defaultProps = {
  copy: {},
  siteOptions: {},
  match: {},
};
SublimicHomeCareStepPage.propTypes = {
  copy: PropTypes.shape({}),
  siteOptions: PropTypes.shape({}),
  match: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
};
const mapState = state => ({
  copy: state.homeCareItemList,
  siteOptions: state.salonConsultaionSiteOptions,
  locale: state.locale,
});

export default connect(mapState)(SublimicHomeCareStepPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicHomeCareStepPage/SublimicHomeCareStep.js